import { Channel } from '@weave/schema-gen-ts/dist/schemas/comm-preference/shared/v1/enums.pb';
import { MessageType_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { CommPreferenceQueries } from '@frontend/api-messaging';
import { AdaptoActions } from '@frontend/adapto-actions';
import { useTranslation } from '@frontend/i18n';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';
import { useAlert } from '@frontend/design-system';
import { useThreadActionsContext } from '../thread-actions';
import { ThreadActionProps } from '../types';

type CommsPreferencesActionProps = Omit<ThreadActionProps, 'label' | 'icon' | 'onClick'>;

export const CommsPreferencesAction = (props: CommsPreferencesActionProps) => {
  const { t } = useTranslation('thread-actions');
  const { groupId, personPhone } = useThreadActionsContext();
  const alert = useAlert();

  const { data: preferenceLinks } = CommPreferenceQueries.useGenerateManagementUrls({
    locationId: groupId,
    channel: Channel.CHANNEL_SMS,
    userChannelAddress: formatPhoneNumberE164(personPhone),
    messageType: MessageType_Enum.MESSAGING_MANUAL,
    includeVoice: true,
  });

  return (
    <AdaptoActions.Action
      {...props}
      label={t('Communication Preferences')}
      icon='message-outgoing'
      onClick={() => {
        const { managementUrl } = preferenceLinks ?? {};
        if (managementUrl) {
          window.open(`${preferenceLinks?.managementUrl}&ref=nwx`, '_blank', 'noopener noreferrer');
        } else {
          alert.error(t('Error opening communication preferences. Try again.'));
        }
      }}
    />
  );
};
